import SortableList from 'views/pages/SortableItem'
import InputCheckbox from './Inputs/InputCheckBox'
import InputRadio from './Inputs/InputRadio'
import Question from './Question'
import SortableComponent from './sortable'
import { useDispatch } from 'react-redux'
import { changeParagraph } from 'store/Quiz/actions'
import GridQuestions from '../Course/components/GridQuestions'
import { useSelector } from 'react-redux'

const QuestionList = ({ dispatch, ...props }) => {
  const dispatchRedux = useDispatch()
  let language = props.language || {}

  return (
    <div className='row'>
      {(() => {
        const current = props.index
        return props?.questions
          ?.filter((item, index) => current === index)
          .map((question, index) => (
            <Question
              {...question}
              isSubmission={props.isSubmission}
              quizPassed={props.quizPassed}
              key={index}
              language={props.language}
              dispatch={dispatch}
            >
              {console.log(question, 'leart50')}
              {(question.options || []).map((optionItem, optionIndex) =>
                question.type === 5 && optionItem.type !== 1 ? null : (
                  <div
                    key={`${question.id}-${optionIndex}`}
                    className='question-row'
                    style={{ position: 'relative' }}
                  >
                    {question.type === 3 ? (
                      <InputCheckbox
                        {...props}
                        question={question}
                        item={optionItem}
                        index={optionIndex}
                        dispatch={dispatch}
                      />
                    ) : question.type !== 4 ? (
                      question.type === 5 ||
                      question.type === 7 ||
                      question.type === 8 ? null : (
                        <InputRadio
                          className={
                            question.type === 6 ? 'hidden-radio-button' : null
                          }
                          {...props}
                          question={question}
                          item={optionItem}
                          index={optionIndex}
                          dispatch={dispatch}
                        />
                      )
                    ) : null}
                    {question.type === 5 ? (
                      <div className='row'>
                        {optionItem && optionItem.type === 1 ? (
                          <div className='col-xl-6 matching-options-wrapper'>
                            <div className='matching-options-container'>
                              <label htmlFor={optionItem.id}>
                                {optionItem.name}
                              </label>
                              <select
                                onChange={(e) => {
                                  // const correctMatch = possibleMatches.map(
                                  //   (match) =>
                                  //     match.find(
                                  //       (option) =>
                                  //         option.match === optionItem.id
                                  //     )
                                  // );

                                  // Distractors (type 3) are selectable too, so
                                  // look the chosen item up among all non-type-1 options
                                  const selectableOptions = (
                                    question.options || []
                                  ).filter((option) => option.type !== 1)

                                  const correctMatch = selectableOptions.find(
                                    (option) => option.match === optionItem.id
                                  )

                                  const chosenMatch = selectableOptions.find(
                                    (option) =>
                                      option.id === e.target.value.split(' ')[1]
                                  )

                                  // Only override with the correct id when the chosen
                                  // item is a duplicate-named copy of the correct match
                                  if (
                                    correctMatch &&
                                    chosenMatch &&
                                    correctMatch.id !== chosenMatch.id &&
                                    correctMatch.name === chosenMatch.name
                                  ) {
                                    dispatch(
                                      props.onChangeSelect(e, correctMatch.id)
                                    )
                                  } else {
                                    dispatch(props.onChangeSelect(e))
                                  }
                                }}
                                value={
                                  optionItem.selected
                                    ? optionItem.id + ' ' + optionItem.selected
                                    : ' '
                                }
                              >
                                <option value={optionItem.id + ' ' + '--'}>
                                  --Select--
                                </option>
                                {(() => {
                                  const selectOptions = question.options
                                    .filter((item) => item.type !== 1)
                                    .sort(function () {
                                      return Math.random() - Math.random()
                                    })
                                  return selectOptions.map((item, index) => (
                                    <option
                                      key={index}
                                      value={optionItem.id + ' ' + item.id}
                                    >
                                      {item.name}
                                    </option>
                                  ))
                                })()}
                              </select>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : question.type === 1 ? (
                      <label htmlFor={optionItem.id}>
                        {optionItem.value === 1
                          ? language.courses
                            ? language.courses.true
                            : null
                          : language.courses
                          ? language.courses.false
                          : null}
                      </label>
                    ) : question.type !== 4 && question.type !== 6 ? (
                      <label htmlFor={optionItem.id}>{optionItem.name}</label>
                    ) : question.type === 6 ? (
                      <label htmlFor={optionItem.id}>
                        <span className='image-option-wrapper'>
                          <img
                            className={`submission-image-option ${
                              optionItem.selected ? 'image-option-selected' : ''
                            }`}
                            src={`${optionItem.url ? optionItem.url : ''}`}
                          />
                        </span>
                      </label>
                    ) : (
                      <label htmlFor={optionItem.id}>{optionItem.name}</label>
                    )}
                  </div>
                )
              )}
              {question.type === 8 && (
                <GridQuestions editMode={false} takeQuiz={true} />
              )}
              {question.type === 7 && (
                <textarea
                  key={question.id}
                  defaultValue={question.answer}
                  className='w-100 p-3'
                  rows={3}
                  onChange={(e) =>
                    dispatchRedux(changeParagraph(e.target.value))
                  }
                />
              )}
              {(() => {
                return question.type === 4 ? (
                  <SortableComponent
                    options={question.options}
                    onReorder={props.reorderOptions}
                  />
                ) : null
              })()}
            </Question>
          ))
      })()}
    </div>
  )
}

export default QuestionList
